module.exports = __webpack_public_path__ + "media/images/university_logos/Kings-College-London-b29b1aae3904efab53e45c2746f8b717.svg";